var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22h-.44C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2h.44v20zM22 11.25H9.75V2h6.44C19.83 2 22 4.17 22 7.81v3.44zM22 16.19c0 3.64-2.17 5.81-5.81 5.81H9.75v-9.25H22v3.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid5);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-5.5fbb3107c697e3d2f77dce25cf76b365.svg";
export { ForwardRef as ReactComponent };